module.exports = __webpack_public_path__ + "img/图片6.0c6adeed.png";